import { defineStore } from 'pinia';

export default defineStore({
    id: 'searchSelectionStore',
    state: {
        recordIds: [],
        datasources: []
    }
});
